import { Component, OnInit } from '@angular/core';
import { ApiEndPoint } from './shared/utility/api-end-point';
import { AuthOktaService } from "./shared/services/auth/auth-okta.service";

// tslint:disable-next-line:ban-types
declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'papertrlui';

  constructor(private authOktaService: AuthOktaService) {
    gtag('config', ApiEndPoint.GOOGLE_ANALYTICS_TRACK_ID, { app_version: ApiEndPoint.ENVIRONMENT });
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const errorDescription = params.get('error_description');
    if (error) {
      sessionStorage.setItem('auth_error', JSON.stringify({ error, errorDescription }));
    }
  }

  async ngOnInit() {
    // Wait for organization ID check to determine Auth0 vs Legacy mode
    await this.authOktaService.getOrganizationId();
  }
}
